export class ValuationBlockAgricultureActivitiesConstants {
    static INHERIT_DATA_LABEL = "Inherit from valuation run";
    static AGRICULTURE_ACTIVITIES_OBJECT_NAME = "agriculture activities";
    static FACTOR_ADJUSTMENT_SUCCESSFULLY_INHERITED_MSG = "factor adjustments successfully inherited from the valuation run";
    static MODAL_OPTIONS = {
        size: "xl", centered: true, backdrop: "static", keyboard: false
    };
}
